const websocketsInstitutional = ``

export default websocketsInstitutional;